import { useState } from "react";
import TuataraMotion from "../../assets/png/Tuatara_in_motion.png";

const BuiltWork = ({ info, infoArray }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="bg-[#292929]">
      <div className="custom-container py-[50px]">
        <div className="font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px]  font-extrabold border-b-[3px] border-[#ffff] text-[#7ABF5B]">
          BUILT TO WORK
        </div>

        <div className="flex flex-wrap	">
          {infoArray.map((item, index) => {
            return (
              <div
                onClick={() => setActiveTab(index)}
                className={`${
                  activeTab == index ? "text-[#7ABF5B]" : "text-[#fff]"
                } cursor-pointer lg:mr-[60px] md:mr-[40px] mr-[10px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] lg:mt-[40px] mt-[20px] font-bold`}
              >
                <span
                  className={`${
                    activeTab == index
                      ? "underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B] pb-[16px]"
                      : ""
                  }`}
                >
                  {item}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="grid lg:grid-cols-2 grid-cols-1  gap-8 md:mt-[43px] mt-0 lg:pb-[150px] md:pb-[100px] sm:pb-[90px] pb-[0px]">
        <div className="custom-container flex w-[-webkit-fill-available] justify-end">
          <div className="lg:max-w-[702px] max-w-[-webkit-fill-available]">
            <div className="font-[Roboto] 2xl:text-[35px] xl:text-[30px] lg:text-[25px] md:text-[20px] text-[17px]  font-extrabold text-[#fff]">
              {info[activeTab].title}
            </div>
            <div className="font-[Roboto] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff]">
              {info[activeTab].subTitle}
            </div>

            <div className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff] mt-[28px]">
              {info[activeTab].dec}
            </div>
            {info[activeTab].dec ? (
              <div className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff] mt-[28px]">
                {info[activeTab].de2}
              </div>
            ) : null}

            {/* <button
              className="rounded-lg bg-[#F2F2F2] border-[#5B792E] border-[4px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#5B792E]  lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px] lg:px-[150px] md:px-[100px] sm:px-[50px] px-[30px] mt-[70px]"
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            >
              FIND A DEALER
            </button> */}
          </div>
        </div>
        <div>
          <img src={info[activeTab].img} alt="" className="h-full object-cover object-left max-h-[652px] w-full" />
        </div>
      </div>
    </div>
  );
};
export default BuiltWork;
